import { Button, Input } from 'tamagui';
export default (() => <Input placeholder="hello world" placeholderTextColor="$color10" />);